module.exports = __webpack_public_path__ + "static/graphicdesign-8fa309cf9d29eb3c5453f6b7153ee6a4.png";